var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"common-no_data"},[_c('div',{staticClass:"img-box"},[_vm._t("img",function(){return [_c('img',{attrs:{"src":require("./img/nodata.svg")}})]})],2),_c('p',{staticClass:"des"},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.$t('Common.暂无内容'))+" ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }